import React, { Component } from 'react';
import $ from "jquery";

import Preview from "./../images/Preview";
import "./../styles/ventanaColores.css";

function NewDate(){
    var CookieDate=new Date();
    CookieDate.setFullYear(CookieDate.getFullYear() +10);
    return CookieDate.toUTCString();
}

function Green(){
    document.cookie="PageColor=Green; expires="+ NewDate() +"; path=/";
    document.documentElement.style.setProperty("--default-color", "#00be6b");
    document.documentElement.style.setProperty("--default-color-hover", "#019a57");
    document.documentElement.style.setProperty("--default-color-light", "#80d493");
}
function Yellow(){
    document.cookie="PageColor=Yellow; expires="+ NewDate() +"; path=/";
    document.documentElement.style.setProperty("--default-color", "#dcc03e");
    document.documentElement.style.setProperty("--default-color-hover", "#c9ad2a");
    document.documentElement.style.setProperty("--default-color-light", "#ead36b");
}
function Orange(){
    document.cookie="PageColor=Orange; expires="+ NewDate() +"; path=/";
    document.documentElement.style.setProperty("--default-color", "#f0932b");
    document.documentElement.style.setProperty("--default-color-hover", "#cc7a20");
    document.documentElement.style.setProperty("--default-color-light", "#f1a34b");
}
function Purple(){
    document.cookie="PageColor=Purple; expires="+ NewDate() +"; path=/";
    document.documentElement.style.setProperty("--default-color", "#936baf");
    document.documentElement.style.setProperty("--default-color-hover", "#76598d");
    document.documentElement.style.setProperty("--default-color-light", "#b585d6");
}
function Blue(){
    document.cookie="PageColor=Blue; expires="+ NewDate() +"; path=/";
    document.documentElement.style.setProperty("--default-color", "#2980b9");
    document.documentElement.style.setProperty("--default-color-hover", "#1f628f");
    document.documentElement.style.setProperty("--default-color-light", "#48a3de");
}

export default class VentanaColores extends Component {

    state = {
        btnSelected: "Green",
        color: "#5abd70"
    }

    changeThemeColor=(formColor)=>{
        formColor.preventDefault();
        var colorSubmit=this.state.btnSelected;
        if(colorSubmit==="Green"){Green()}
        if(colorSubmit==="Yellow"){Yellow()}
        if(colorSubmit==="Orange"){Orange()}
        if(colorSubmit==="Purple"){Purple()}
        if(colorSubmit==="Blue"){Blue()}
        this.props.closeWindow();
    }

    selectColor = (c) => {
        this.setState({btnSelected: c});
    }

    updateVisibility(){
        if(this.props.isOpen){
            $("#VentanaColores").fadeIn();
            $('body').css('overflow-y', 'hidden');
        }else{
            $("#VentanaColores").fadeOut();
            $('body').css('overflow-y', 'auto');
        }
    }

    componentDidMount(){
        $("#VentanaColores").css("display","block");
        $("#VentanaColores").hide();

    }
    componentDidUpdate(prevProps){
        if (prevProps.isOpen !== this.props.isOpen){
            this.updateVisibility();
        }
    }

    render() {
        return (
            <div className="modal" id="VentanaColores">
                <div className="modalContent">
                    <div className="card">
                        <div className="body-card">
                            <div className="colores">
                                <span>Elegí el color que prefieras</span>
                                <div
                                    className={"btnColor" + ((this.state.btnSelected === "Green")? " btnSelected" : "")}
                                    onClick={() => this.setState({btnSelected: "Green", color: "#00be6b"})}
                                    style={{background: "#00be6b"}}
                                >
                                    <i className="material-icons-round icono">check</i>
                                </div>
                                <div
                                    className={"btnColor" + ((this.state.btnSelected === "Yellow")? " btnSelected" : "")}
                                    onClick={() => this.setState({btnSelected: "Yellow", color: "#dcc03e"})}
                                    style={{background: "#dcc03e"}}
                                >
                                    <i className="material-icons-round icono">check</i>
                                </div>
                                <div
                                    className={"btnColor" + ((this.state.btnSelected === "Orange")? " btnSelected" : "")}
                                    onClick={() => this.setState({btnSelected: "Orange", color: "#f0932b"})}
                                    style={{background: "#f0932b"}}
                                >
                                    <i className="material-icons-round icono">check</i>
                                </div>
                                <div
                                    className={"btnColor" + ((this.state.btnSelected === "Purple")? " btnSelected" : "")}
                                    onClick={() => this.setState({btnSelected: "Purple", color: "#936baf"})}
                                    style={{background: "#936baf"}}
                                >
                                    <i className="material-icons-round icono">check</i>
                                </div>
                                <div
                                    className={"btnColor" + ((this.state.btnSelected === "Blue")? " btnSelected" : "")}
                                    onClick={() => this.setState({btnSelected: "Blue", color: "#2980b9"})}
                                    style={{background: "#2980b9"}}
                                >
                                    <i className="material-icons-round icono">check</i>
                                </div>
                            </div>
                            <div className="previewCaja">
                                <span>Vista previa</span>
                                <Preview fill={this.state.color} className="preview" width="51%" height="51%"/>
                            </div>
                        </div>
                        <div className="end-card confirmFooter">
                            <div className="btnCancelar" onClick={this.props.closeWindow}>CANCELAR</div>
                            <div className="btn" onClick={this.changeThemeColor}>Confirmar</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
